import React from 'react';
import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
// import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import {
  // DateButton,
  formatUTCDate,
  DateCheckboxButton,
} from 'pages/ticketV2/common';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import { Roles } from 'utils/constants';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const ContainerFooter = ({
  currentTicket,
  onToggleDate,
  form,
  reservations,
  assignTicketTexts,
  loggedUser,
  locale,
}) => {
  // Hooks
  const isOperator = loggedUser.type === Roles.OPERATOR;
  const intl = useIntl();
  const i18n = translations.Tickets(intl).edit.ticketEditCard;
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  const { errors } = form;

  // Renders
  const renderError = (key, labelKey, marginTop = 0) => {
    if (errors[key] && errors[key]?.type === 'required')
      return (
        <Typography
          style={{
            marginTop: marginTop,
          }}
          variant={'body2'}
          color="primary"
          fontFamily={'Suisse-Intl'}
        >
          {i18n.fields[labelKey ? labelKey : key].error}
        </Typography>
      );
    return null;
  };

  if (currentTicket?.capacity >= reservations?.length && !isOperator)
    return null;

  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      {currentTicket ? (
        <Stack
          gap={'25px'}
          sx={{
            p: '30px',
            boxShadow: '0px 0px 5px 0px rgba(51, 51, 51, 0.05)',
            bgcolor: 'white',
          }}
        >
          <Stack direction={'row'} alignItems={'center'} gap={'10px'}>
            {isLgUp ? (
              <div style={{ fontSize: '27px', paddingTop: '4px' }}>
                <CalendarTodayOutlinedIcon fontSize="inherit" />
              </div>
            ) : (
              <CalendarTodayOutlinedIcon fontSize="medium" sx={{ mb: '4px' }} />
            )}
            <a
              id="dates-selection"
              style={{
                position: 'relative',
                top: '-130px',
                visibility: 'hidden',
              }}
            />
            <Typography
              variant="m-bold"
              fontFamily={'Suisse-Intl'}
              component={'h2'}
            >
              {
                assignTicketTexts[
                  isOperator ? 'operatorDatesTitle' : 'datesTitle'
                ]
              }
            </Typography>
          </Stack>
          <div>
            <Typography variant="body1" fontFamily={'Suisse-Intl'}>
              {isOperator
                ? `${assignTicketTexts['operatorDatesSubtitle']} ${
                    reservations?.length || ''
                  }${assignTicketTexts['operatorDatesSubtitleDynamic']}`
                : currentTicket?.capacity === 1
                ? assignTicketTexts['singleDateSubtitle']
                : assignTicketTexts['datesSubtitle']}
            </Typography>
            {isOperator ? (
              <Typography variant="body1" fontFamily={'Suisse-Intl'}>
                {assignTicketTexts.operatorDatesSecondSubtitle}
              </Typography>
            ) : null}
          </div>
          <Stack
            direction={'row'}
            gap={isSmDown ? '15px' : '25px'}
            alignItems={'center'}
            justifyContent={isMdDown && isOperator ? 'center' : 'flex-start'}
            flexWrap={'wrap'}
          >
            {/* {reservations?.map((res) => (
              <DateButton
                key={res.date}
                variant="contained"
                onClick={() => onToggleDate(res.date)}
                selected={res.selected}
                sx={{ width: 120, p: '10px' }}
              >
                <span>{formatUTCDate({ date: res.date, locale })}</span>
                {res.selected && <CheckOutlinedIcon fontSize="small" />}
              </DateButton>
            ))} */}

            {reservations?.map((res) => (
              <DateCheckboxButton
                key={res.date}
                checked={res.selected}
                onChange={() => onToggleDate(res.date)}
                label={formatUTCDate({ date: res.date, locale })}
              />
            ))}
          </Stack>
          {renderError('date')}
          {isOperator ? (
            <Box
              bgcolor={'#EEEEEE'}
              border={'1px solid #A3A3A3'}
              padding={'30px 15px'}
            >
              <Stack
                flexDirection={'row'}
                gap={'15px'}
                alignItems={'flex-start'}
              >
                <InfoOutlinedIcon sx={{ color: '#333333' }} />
                <Stack>
                  <Typography
                    variant="body1-bold"
                    sx={{ mb: '15px' }}
                    fontFamily={'Suisse-Intl'}
                  >
                    {assignTicketTexts.operatorBoxTitle}
                  </Typography>
                  <Typography variant="body1" fontFamily={'Suisse-Intl'}>
                    {assignTicketTexts.operatorBoxSubTitleOne}
                  </Typography>{' '}
                </Stack>
              </Stack>
            </Box>
          ) : null}
        </Stack>
      ) : null}
    </Box>
  );
};
export default ContainerFooter;
